import { Language, translations } from '@/data/translations';
import { Attraction } from '@/types/attraction';
import { featuredAttractions } from '@/data/attractions';

export const getTranslatedAttractions = (language: Language): Attraction[] => {
  return featuredAttractions.map(attraction => {
    const attractionTranslations = translations[language].attractions[attraction.id as keyof typeof translations[Language]['attractions']];
    
    return {
      ...attraction,
      name: attractionTranslations?.name || attraction.name,
      description: attractionTranslations?.description || attraction.description,
      shortDescription: attractionTranslations?.shortDescription || attraction.shortDescription,
      features: attractionTranslations?.features || attraction.features,
      guestBenefits: attractionTranslations?.guestBenefits || attraction.guestBenefits,
      distance: attractionTranslations?.distance || attraction.distance,
      duration: attractionTranslations?.duration || attraction.duration,
    };
  });
};

export const getTranslatedAttraction = (attractionId: string, language: Language): Attraction | null => {
  const attraction = featuredAttractions.find(att => att.id === attractionId);
  if (!attraction) return null;

  const attractionTranslations = translations[language].attractions[attractionId as keyof typeof translations[Language]['attractions']];
  
  return {
    ...attraction,
    name: attractionTranslations?.name || attraction.name,
    description: attractionTranslations?.description || attraction.description,
    shortDescription: attractionTranslations?.shortDescription || attraction.shortDescription,
    features: attractionTranslations?.features || attraction.features,
    guestBenefits: attractionTranslations?.guestBenefits || attraction.guestBenefits,
    distance: attractionTranslations?.distance || attraction.distance,
    duration: attractionTranslations?.duration || attraction.duration,
  };
};
